import { Component, OnInit } from '@angular/core';
import { ActivityService } from '../services/activity.service';

interface NavItem {
  id?: string,
  url?: string,
  items?: NavItem[]
}

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  items: NavItem[] = [
    {
      id: 'presentation.title',
      url: '/presentation',
    }, {
      id: 'activity.friends-day.title',
      url: '/activity/1'
    }, {
      id: 'activity.horse-rythm.title',
      items: [
        {
          id: 'activity.wednesday-market.title',
          url: '/activity/7'
        },
        {
          id: 'activity.friday-market.title',
          url: '/activity/8'
        },
        {
          id: 'activity.horse-drawn-carriage-ride.title',
          url: '/activity/9'
        }
      ]
    }, {
      id: 'activity.massages.title',
      url: '/activity/5'
    }, {
      id: 'contact.title',
      url: "/contact"
    }
  ];

  showMobileMenu: boolean = false;
  indexMobileSubMenu: number = -1;

  constructor(
    private activityService: ActivityService
  ) { }

  ngOnInit(): void {
  }

  toggleShowMobileMenu() {
    this.showMobileMenu = !this.showMobileMenu;
  }

}
